import type { Option } from "@performyard/py-components/src/types/Option";

import { IStrategyCategory, getStrategyCategories } from "../../../../../../api/services";

/**
 * Fetch and filter category options based on search term
 * Uses a cache to avoid repeated API calls
 */
export const createFetchCategoryOptions = (categoriesCache: React.MutableRefObject<IStrategyCategory[]>) => {
	return async (searchTerm: string): Promise<Option<{ id: string; name: string }>[]> => {
		if (categoriesCache.current.length === 0) {
			const { categories } = await getStrategyCategories();
			categoriesCache.current = categories.filter((category) => !category?.deleted);
		}

		const filtered = categoriesCache.current.filter((category) =>
			category.name.toLowerCase().includes(searchTerm.toLowerCase())
		);

		return filtered.map((category) => ({
			label: category.name,
			value: { id: category._id, name: category.name },
		}));
	};
};

/**
 * Fetch and filter outlook options based on search term
 */
export const createFetchOutlookOptions = (
	outlooksData: { colors: { id: string; name: string; color: string }[] } | undefined
) => {
	return async (searchTerm: string): Promise<Option<{ id: string; name: string; color: string }>[]> => {
		const outlooks = outlooksData?.colors || [];
		const filtered = outlooks.filter((outlook) => outlook.name.toLowerCase().includes(searchTerm.toLowerCase()));
		return filtered.map((outlook) => ({
			label: outlook.name,
			value: { id: outlook.id, name: outlook.name, color: outlook.color },
		}));
	};
};
